import { styled } from 'styled-components';
import CategoryIcon from '../../../../../gel/iconography/icons';

export const StyledChecklistItemTickIcon = styled(CategoryIcon)`
    fill: currentcolor;
`;
